// extracted by mini-css-extract-plugin
module.exports = {"baseBtn":"DeleteTransportBtn_baseBtn__1FHLj"};